import { Box, Typography } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import { ReactNode } from "react";
import { replaceUnderScoreAddSpace } from "@/utils/utils";
import {
  HOME_CARE_ROS_LABEL_CELL_SX,
  HOME_CARE_ROS_LABEL_TEXT_SX,
  HOME_CARE_ROS_OPTIONS_CELL_SX,
  HOME_CARE_ROS_ROW_SX,
} from "../home-care-ros-constant";

export interface HomeCareRosSystemRowProps {
  name: string;
  children: ReactNode;
  action?: ReactNode;
  sx?: SxProps<Theme>;
}

const HomeCareRosSystemRow = ({
  name,
  children,
  action,
  sx,
}: HomeCareRosSystemRowProps) => (
  <Box sx={[HOME_CARE_ROS_ROW_SX, ...(Array.isArray(sx) ? sx : [sx])]}>
    <Box sx={HOME_CARE_ROS_LABEL_CELL_SX}>
      <Typography component="span" sx={HOME_CARE_ROS_LABEL_TEXT_SX}>
        {replaceUnderScoreAddSpace(name || "-")}
      </Typography>
    </Box>
    <Box sx={HOME_CARE_ROS_OPTIONS_CELL_SX}>{children}</Box>
    {action && (
      <Box display="flex" alignItems="flex-start" pt={0.5} pr={0.5}>
        {action}
      </Box>
    )}
  </Box>
);

export default HomeCareRosSystemRow;
